<template>
  <v-container fluid tag="section">
    <base-material-card-list :item='item' ref="table">
      <template v-slot:title="{ loading }">
          <v-card-text>
            <v-row>
              <v-col cols="12" md='2' class="pr-0">
                <v-select
                  hide-details
                  outlined dense
                  label="年份选择"
                  :items='yearItems'
                  @change="loadData"
                  item-text="label"
                  item-value="value"
                  clearable
                  clear-icon="mdi-close-circle-outline"
                  v-model='item.params.year'>
                </v-select>
              </v-col>
              <v-col cols="12" md='2' class="pr-0">
                <v-select
                  hide-details
                  outlined dense
                  label="月份选择"
                  :items='monthItems'
                  @change="loadData"
                  item-text="label"
                  item-value="value"
                  clearable
                  clear-icon="mdi-close-circle-outline"
                  v-model='item.params.month'>
                </v-select>
              </v-col>
              <v-col cols="12" md='2'>
                <v-btn color="primary" :loading="loading" @click="loadData" class="mr-1 px-2" dark depressed>
                  <v-icon>mdi-magnify</v-icon>
                  查询
                </v-btn>
                <v-btn color="green" @click="add" class="mr-1 px-2" dark depressed>
                  <v-icon>mdi-plus</v-icon>
                  新增
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
        <template v-slot:content="{ records }">
          <v-row>
            <v-col cols="12" md='3' v-for="(item, idx) in records" :key="idx">
              <v-card class="rounded-lg" elevation="0" min-height='330'>
                <v-card-title class="size-15">
                  <v-chip label small color="primary">{{item.workMonth}}月</v-chip>
                  <v-spacer></v-spacer>
                  出勤{{item.workDays}}天
                </v-card-title>
                <v-card-subtitle class="mt-3">排班明细</v-card-subtitle>
                <v-card-text>
                  <v-card elevation="0" height="200" class="overflow-auto">
                    <v-card-title v-for="(i, index) in item.workSettingList" :key="index" class="py-1 px-0 size-13">
                      {{i.workTime | formatDay}}
                      <span v-if="i.legal === 1">
                      【法定】
                      </span>
                      <v-spacer></v-spacer>
                      <v-chip label small dark :color="i.work === 1 ? 'green' : 'red'">{{i.work === 1 ? '班' : '休'}}</v-chip>
                    </v-card-title>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
      </template>
    </base-material-card-list>
    <add-view :item="addModal" @on-load-data="loadData" ></add-view>
  </v-container>
</template>

<script>
  import { selectData, selectMonthData } from '@/utils/tool.js'
  import AddView from './components/Add'

  export default {
    name: 'OfficeWorkSet',
    components: {
      AddView
    },
    data() {
      return {
        monthItems: selectMonthData(),
        yearItems: selectData(3),
        loading: false,
        addModal: { show: false, data: {} },
        item: {
          path: 'office/work/setting/list',
          params: {
            year: '',
            month: ''
          }
        },
      }
    },
    methods: {
      add () {
        this.addModal = { show: true }
      },
      loadData () {
        this.$refs.table.loadData()
      }
    }
  }
</script>

<style>
</style>
